import React from 'react';
import './ProductTable.css';

const ProductTable = ({ title, headers, rows, className }) => {
  return (
    <div className={`product-table-container ${className || ''}`}>
      <table className="product-table">
        <thead>
          <tr className="table-header">
            {headers.map((header, index) => (
              <th key={index} colSpan={header.colspan || 1}>
                <span className="data-table-header-text">
                  <center>{header.text}</center>
                </span>
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((row, rowIndex) => (
            <tr key={rowIndex}>
              {row.map((cell, cellIndex) => (
                <td 
                  key={cellIndex} 
                  colSpan={cell.colspan || 1} 
                  rowSpan={cell.rowspan || 1}
                >
                  <div className="td-content-wrapper">
                    <div className="td-content">
                      <center dangerouslySetInnerHTML={{ __html: cell.content }}></center>
                    </div>
                  </div>
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ProductTable;